import { render, staticRenderFns } from "./PatientDiagnosisCard.vue?vue&type=template&id=55c149ad&scoped=true&"
import script from "./PatientDiagnosisCard.vue?vue&type=script&lang=js&"
export * from "./PatientDiagnosisCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientDiagnosisCard.vue?vue&type=style&index=0&id=55c149ad&prod&scoped=true&lang=css&"
import style1 from "./PatientDiagnosisCard.vue?vue&type=style&index=1&id=55c149ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c149ad",
  null
  
)

export default component.exports